import { FilterLines, SearchMd } from "@untitledui/icons";
import { Button } from "@/components/base/buttons/button";
import { Input } from "@/components/base/input/input";
import { cx } from "@/utils/cx";

type SearchAndFilterActionsProps = {
  search: string;
  onSearchChange: (value: string) => void;
  onToggleFilters: () => void;
  className?: string;
  searchClassName?: string;
};

export const SearchAndFilterActions = ({
  search,
  onSearchChange,
  onToggleFilters,
  className,
  searchClassName = "w-96",
}: SearchAndFilterActionsProps) => (
  <div className={cx("flex items-center flex-row gap-2", className)}>
    <Input
      size="sm"
      inputClassName="text-sm"
      className={searchClassName}
      value={search}
      onChange={onSearchChange}
      placeholder="Search Creator Name..."
      icon={SearchMd}
    />
    <Button
      className="font-medium text-xs"
      color="secondary"
      onClick={onToggleFilters}
      iconLeading={<FilterLines className="w-4 h-4" />}
    >
      Filter
    </Button>
  </div>
);
